import { createSlice } from '@reduxjs/toolkit';

const teacherNames = createSlice({
  name: 'teacherNames',
  initialState: {
    teacherNamesArr: '',
    subjectsTeacherObj: {},
  },
  reducers: {
    setTeacherNames(state, action) {
      state.teacherNamesArr = action.payload;
    },
    setSubjectsTeacher(state, action) {
      state.subjectsTeacherObj = action.payload;
    },
  },
});

export const { setTeacherNames, setSubjectsTeacher } = teacherNames.actions;

export const getTeacherNames = state => state.teacherNames.teacherNamesArr;
export const getSubjectsTeacher = state => state.teacherNames.subjectsTeacherObj;

export default teacherNames.reducer;
